import { render, staticRenderFns } from "./registerNow.vue?vue&type=template&id=98723066&scoped=true"
import script from "./registerNow.vue?vue&type=script&lang=js"
export * from "./registerNow.vue?vue&type=script&lang=js"
import style0 from "./registerNow.vue?vue&type=style&index=0&id=98723066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98723066",
  null
  
)

export default component.exports